.eventBoundary {
  display: contents;
}

.controls {
  display: flex;
  align-items: center;
  gap: 28px;
  margin-right: 8px;
}

.body {
  max-height: min(816px, calc(100vh - 164px));
  margin-top: 16px;
  padding: 16px 12px 16px 0;
  overflow-y: auto;
  border-top: 1px solid var(--gray-300);
  border-bottom: 1px solid var(--gray-300);
}

.placeholder {
  display: flex;
  height: 340px;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.footer {
  padding-top: 16px;
}

.eventsToggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
}

.mobileRows {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 12px;
}

.mobilePicker {
  position: relative;
  width: 100%;
}

@media (max-width: 767px) {
  .controls {
    gap: 8px;
  }

  .body {
    max-height: calc(100vh - 240px);
    max-height: calc(100dvh - 240px);
  }
}
